import { gql } from "@apollo/client";

export const BUILDING_OVERVIEW_FIELDS_FRAGMENT = gql`
  fragment BuildingOverviewFieldsV2 on BuildingInterface {
    id
    slug
    name
    showRbi
    description
    amenities
    amenitiesDetails
    includedUtilities
    utilitiesIncluded
    petFriendly
    additionalDetails
    contactEmail
    contactName
    contactPhone
    applicationUrl
    isChamp
    hasAccessibleUnits
    address {
      street1
      city
      state
      zipCode
    }
    location {
      latitude
      longitude
    }
    geocode {
      formattedAddress
    }
    availability {
      status
      bedrooms
      accessibleBedrooms
      minRent
      maxRent
      rbi
      allRbi
      bedroomsInfo {
        bedroom
        accessible
        unitCount
        minRent
        maxRent
        rbi
        allRbi
      }
    }
    url
    featured {
      id
      bannerUrl
    }
    units {
      deeplyAffordable
    }
    images {
      id
      name
      caption
      location
      url
      thumbnailUrl
      lightboxUrl
      accessibilityFeatures
    }
    housingLottery {
      id
      endDate
    }
    housingVacancy {
      id
      isCurrent
      isActive
      isExpired
    }
    unitGroups {
      id
      isAffordable
      mobilityAccessible
      visionAccessible
      hearingAccessible
    }
    hasAgeRestrictions
    ageRestrictionType
    ageRestrictionDetail
    ageRestrictionOrDisabled
    ageRestrictionSize
    __typename
  }
`;

export default BUILDING_OVERVIEW_FIELDS_FRAGMENT;
